import HttpCliente from "../servicios/HttpCliente";

export const EnviarArchivoHoras = async (payload) => {
  return await HttpCliente.post("/Transacciones/ProcesarArchivoHoras", payload);
};

export const EnviarArchivoHorasKL = async (payload) => {
  return await HttpCliente.post("/Transacciones/ProcesarArchivoHorasKL", payload);
};

export const ObtenerTransaccionesColaborador = async (idTransaccion) => {
  return await HttpCliente.get(`/Transacciones/${idTransaccion}`);
};

export const ObtenerLogError = async (idTransaccion) => {
  return await HttpCliente.get(`/Logs/${idTransaccion}`);
};

export const ExportarPlantillaCargaMasiva = async (idContrato) => {
  return await HttpCliente.get(
    `/Contratos/${idContrato}/plantilla-carga-masiva`,
    {
      responseType: 'blob',
      headers: {
        'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }
    }
  );
};


